import { render, staticRenderFns } from "./IM_3_3.vue?vue&type=template&id=005c35ef&scoped=true&"
import script from "./IM_3_3.vue?vue&type=script&lang=js&"
export * from "./IM_3_3.vue?vue&type=script&lang=js&"
import style0 from "./IM_3_3.vue?vue&type=style&index=0&id=005c35ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c35ef",
  null
  
)

export default component.exports